module.exports = __webpack_public_path__ + "60080d4a5960ae50508b4b63259ca9d6.pdf";